import React from "react";
import { SvgProps } from "../types";

const Icon: React.FC<React.PropsWithChildren<SvgProps>> = (props) => {
  return (
    <svg width="50" height="41" viewBox="0 0 50 41" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="20.5628" cy="20.4372" r="3.62869" transform="rotate(-90 20.5628 20.4372)" fill="#F59C53" />
      <circle
        cx="20.1594"
        cy="20.8406"
        r="18.5466"
        transform="rotate(-90 20.1594 20.8406)"
        stroke="white"
        strokeWidth="3.2255"
      />
      <circle cx="30.2395" cy="20.4372" r="3.62869" transform="rotate(-90 30.2395 20.4372)" fill="#F59C53" />
      <circle
        cx="29.8361"
        cy="20.8406"
        r="18.5466"
        transform="rotate(-90 29.8361 20.8406)"
        stroke="white"
        strokeWidth="3.2255"
      />
    </svg>
  );
};

export default Icon;
